import React from "react";
import { motion } from "framer-motion";
import { useTranslate } from "../../i18n/useTranslate";

export default function ChartCard({ title, subtitle, children, action, badge, className="", live=false }) {
  const t = useTranslate();
  return (
    <motion.div
      initial={{ opacity:0, y:16 }}
      animate={{ opacity:1, y:0 }}
      transition={{ duration:0.4 }}
      className={`card p-5 ${className}`}
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="flex items-center gap-2">
            {title && <h3 className="text-sm font-black text-slate-900">{t(title)}</h3>}
            {live && (
              <span className="flex items-center gap-1 text-[9px] font-black text-emerald-600">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 live-dot" />{t("LIVE")}
              </span>
            )}
            {badge && (
              <span className="text-[9px] font-black bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full">{t(badge)}</span>
            )}
          </div>
          {subtitle && <p className="text-xs text-slate-400 mt-0.5">{t(subtitle)}</p>}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
      {children}
    </motion.div>
  );
}
